var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./partials/addresses-and-payments/intro.j2"] = require( "./partials/addresses-and-payments/intro.j2" );
dependencies["./partials/addresses-and-payments/address-payment-header.j2"] = require( "./partials/addresses-and-payments/address-payment-header.j2" );
dependencies["./partials/add-new-address-payment-section.j2"] = require( "./partials/add-new-address-payment-section.j2" );
dependencies["./partials/address-form.j2"] = require( "./partials/address-form.j2" );
dependencies["./partials/saved-addresses-list.j2"] = require( "./partials/saved-addresses-list.j2" );
dependencies["./partials/saved-payment-list.j2"] = require( "./partials/saved-payment-list.j2" );
dependencies["./partials/orphan-payments.j2"] = require( "./partials/orphan-payments.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/address.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n<section id=\"u-skip-anchor\" class=\"s-account o-row o-column o-extra-small--12 o-medium--9 o-large--10 c-dashboard c-address-book__section js-address-payments-container\">\n\n    ";
if(env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup(((lineno = 4, colno = 19, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["relationships"]))),"profile")),"registryInfo")),"registries")) > 0) {
output += "\n\n    <div class=\"o-row g-address-payment\">\n\n        ";
env.getTemplate("./partials/addresses-and-payments/intro.j2", false, "account/templates/address.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n    </div>\n\n    ";
})});
}
output += "\n\n    <div class=\"o-row g-address-payment\">\n\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"deleteSuccessModal")) {
output += "\n\n        <div class=\"c-form__field has-success\">\n\n            <div class=\"c-form-block\">\n\n                <p class=\"c-form-block__p\">\n\n                    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"deleteAddressSuccess")) {
output += "\n\n                        ";
output += runtime.suppressValue((lineno = 26, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-address-delete",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n                    ";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"deletePaymentSuccess")) {
output += "\n\n                        ";
output += runtime.suppressValue((lineno = 30, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-payment-delete",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n                    ";
;
}
;
}
output += "\n\n                </p>\n\n            </div>\n\n        </div>\n\n        ";
;
}
output += "\n\n        ";
env.getTemplate("./partials/addresses-and-payments/address-payment-header.j2", false, "account/templates/address.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n    </div>\n\n    ";
env.getTemplate("./partials/add-new-address-payment-section.j2", false, "account/templates/address.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n    ";
output += "\n    <div class=\"o-row g-address-payment\" data-qa-addresses-payments-section>\n\n        ";
frame = frame.push();
var t_15 = (lineno = 51, colno = 32, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["userAddresses"]));
if(t_15) {var t_14 = t_15.length;
for(var t_13=0; t_13 < t_15.length; t_13++) {
var t_16 = t_15[t_13];
frame.set("item", t_16);
frame.set("loop.index", t_13 + 1);
frame.set("loop.index0", t_13);
frame.set("loop.revindex", t_14 - t_13);
frame.set("loop.revindex0", t_14 - t_13 - 1);
frame.set("loop.first", t_13 === 0);
frame.set("loop.last", t_13 === t_14 - 1);
frame.set("loop.length", t_14);
output += "\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"editAddress") && runtime.memberLookup(((lineno = 53, colno = 56, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"id") == runtime.memberLookup((t_16),"id")) {
output += "\n\n                ";
if(runtime.memberLookup((t_16),"id") == runtime.memberLookup((runtime.memberLookup((runtime.memberLookup(((lineno = 55, colno = 42, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["relationships"]))),"profile")),"profile")),"defaultShippingAddressId")) {
output += "\n\n                    ";
var t_17;
t_17 = "c-address-form--default-address";
frame.set("defaultClass", t_17, true);
if(frame.topLevel) {
context.setVariable("defaultClass", t_17);
}
if(frame.topLevel) {
context.addExport("defaultClass", t_17);
}
output += "\n\n                ";
;
}
else {
output += "\n\n                    ";
var t_18;
t_18 = "";
frame.set("defaultClass", t_18, true);
if(frame.topLevel) {
context.setVariable("defaultClass", t_18);
}
if(frame.topLevel) {
context.addExport("defaultClass", t_18);
}
output += "\n\n                ";
;
}
output += "\n\n            ";
output += "\n            <div class=\"o-column o-extra-small--12 o-large--6 u-no-gutters\">\n\n                <div class=\"c-address-form c-address-form--edit ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "defaultClass"), env.opts.autoescape);
output += "\">\n\n                    ";
env.getTemplate("./partials/address-form.j2", false, "account/templates/address.j2", null, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
t_19.render(context.getVariables(), frame, function(t_22,t_20) {
if(t_22) { cb(t_22); return; }
output += t_20
output += "\n\n                </div>\n\n            </div>\n\n            ";
})});
}
else {
output += "\n\n            <div class=\"o-row c-address-book__divider\">\n\n                ";
env.getTemplate("./partials/saved-addresses-list.j2", false, "account/templates/address.j2", null, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
t_23.render(context.getVariables(), frame, function(t_26,t_24) {
if(t_26) { cb(t_26); return; }
output += t_24
output += "\n\n            ";
})});
}
output += "\n\n                ";
env.getTemplate("./partials/saved-payment-list.j2", false, "account/templates/address.j2", null, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
t_27.render(context.getVariables(), frame, function(t_30,t_28) {
if(t_30) { cb(t_30); return; }
output += t_28
output += "\n\n            </div>\n\n        ";
})});
}
}
frame = frame.pop();
output += "\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12 o-large--6 c-address-book__payments-container c-address-book__orphan-offset\">\n\n                ";
env.getTemplate("./partials/orphan-payments.j2", false, "account/templates/address.j2", null, function(t_33,t_31) {
if(t_33) { cb(t_33); return; }
t_31.render(context.getVariables(), frame, function(t_34,t_32) {
if(t_34) { cb(t_34); return; }
output += t_32
output += "\n\n            </div>\n\n        </div>\n\n    </div>\n\n</section>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/address.j2"] , dependencies)